import React from "react";
import Subheader from "../../UI/Subheader";

const FormAddressFeeConfirmation = ({ deliveryFee, distance }) => {
  return (
    <>
      <Subheader>Frais de livraison</Subheader>
      <div>
        <p style={{ textAlign: "center", marginTop: 40 }}>
          <i>
            {`Vous êtes environ à `}
            <strong>{`${distance.text}`}</strong> {` du commerce.`}
            <br />
            {` Selon la charte, le frais de livraison est de `}
            <strong>{`${deliveryFee}$`}</strong>
          </i>
        </p>
      </div>
    </>
  );
};

export default FormAddressFeeConfirmation;
